<ng-container *ngIf="isOpen">
    <div class="modal show" style="display: block; z-index: 9999;" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modalTitle }}</h5>
                    <button type="button" class="btn-close" (click)="onClose()"></button>
                </div>
                <div class="modal-body">
                    <!-- Identity Document Upload -->
                    <div *ngIf="isIdentity">
                        <p class="text-muted mb-4">
                            {{ 'seller_setup.identity_document_description' | translate }}
                        </p>

                        <!-- Document Type Selection -->
                        <div class="mb-4">
                            <label class="form-label fw-bold">
                                {{ 'seller_setup.select_document_type' | translate }}
                                <span class="text-danger">*</span>
                            </label>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="idDocType"
                                    id="modalIdCard"
                                    value="IdCard"
                                    (change)="onIdDocTypeChange('IdCard')"
                                    [checked]="selectedIdDocType === 'IdCard'">
                                <label class="form-check-label" for="modalIdCard">
                                    {{ 'seller_setup.id_card' | translate }}
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="idDocType"
                                    id="modalPassport"
                                    value="Passport"
                                    (change)="onIdDocTypeChange('Passport')"
                                    [checked]="selectedIdDocType === 'Passport'">
                                <label class="form-check-label" for="modalPassport">
                                    {{ 'seller_setup.passport' | translate }}
                                </label>
                            </div>
                        </div>

                        <!-- File Upload Section -->
                        <div *ngIf="selectedIdDocType" class="upload-section">
                            <!-- Info message for ID Card -->
                            <div *ngIf="selectedIdDocType === 'IdCard'" class="alert alert-info mb-3">
                                <i class="bi bi-info-circle-fill me-2"></i>
                                {{ 'seller_setup.id_card_both_sides_message' | translate }}
                            </div>

                            <label class="form-label fw-bold">
                                {{ 'seller_setup.upload_file' | translate }}
                                <span class="text-danger">*</span>
                            </label>

                            <!-- File Input -->
                            <div *ngIf="!uploadState.file && !uploadState.uploaded" class="mb-3">
                                <input
                                    type="file"
                                    class="form-control"
                                    id="modalIdFile"
                                    [accept]="ACCEPTED_TYPES"
                                    (change)="onFileSelected($event)">
                                <div class="form-text">
                                    {{ 'seller_setup.file_requirements' | translate }}
                                    ({{ 'seller_setup.max_file_size' | translate }}: 5MB)
                                </div>
                            </div>

                            <!-- File Preview -->
                            <div *ngIf="uploadState.file && !uploadState.uploaded" class="file-preview mb-3">
                                <div class="d-flex align-items-center justify-content-between p-3 bg-light rounded">
                                    <div>
                                        <i class="bi bi-file-earmark-text me-2"></i>
                                        <span class="fw-bold">{{ uploadState.fileName }}</span>
                                        <small class="text-muted d-block">{{ formatFileSize(uploadState.fileSize) }}</small>
                                    </div>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-danger"
                                        (click)="clearFile()"
                                        [disabled]="uploadState.uploading">
                                        <i class="bi bi-x"></i>
                                        {{ 'common.remove' | translate }}
                                    </button>
                                </div>
                            </div>

                            <!-- Upload Button -->
                            <button
                                *ngIf="uploadState.file && !uploadState.uploaded && !uploadState.uploading"
                                type="button"
                                class="btn btn-primary"
                                (click)="uploadDocument()"
                                [disabled]="!canUpload">
                                <i class="bi bi-upload me-2"></i>
                                {{ 'seller_setup.upload_button' | translate }}
                            </button>

                            <!-- Uploading Spinner -->
                            <div *ngIf="uploadState.uploading" class="text-center py-3">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
                                </div>
                                <p class="mt-2 mb-0">{{ 'seller_setup.uploading' | translate }}</p>
                            </div>

                            <!-- Success State -->
                            <div *ngIf="uploadState.uploaded" class="alert alert-success">
                                <i class="bi bi-check-circle-fill me-2"></i>
                                {{ 'seller_setup.upload_success' | translate }}
                            </div>

                            <!-- Error State -->
                            <div *ngIf="uploadState.error" class="alert alert-danger">
                                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                                {{ uploadState.error }}
                                <button
                                    type="button"
                                    class="btn btn-sm btn-outline-danger ms-3"
                                    (click)="retryUpload()">
                                    {{ 'common.retry' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Registration Document Upload -->
                    <div *ngIf="isRegistration">
                        <p class="text-muted mb-4">
                            {{ 'seller_setup.registration_document_description' | translate }}
                        </p>

                        <label class="form-label fw-bold">
                            {{ 'seller_setup.upload_registration' | translate }}
                            <span class="text-danger">*</span>
                        </label>

                        <!-- File Input -->
                        <div *ngIf="!uploadState.file && !uploadState.uploaded" class="mb-3">
                            <input
                                type="file"
                                class="form-control"
                                id="modalRegFile"
                                [accept]="ACCEPTED_TYPES"
                                (change)="onFileSelected($event)">
                            <div class="form-text">
                                {{ 'seller_setup.file_requirements' | translate }}
                                ({{ 'seller_setup.max_file_size' | translate }}: 5MB)
                            </div>
                        </div>

                        <!-- File Preview -->
                        <div *ngIf="uploadState.file && !uploadState.uploaded" class="file-preview mb-3">
                            <div class="d-flex align-items-center justify-content-between p-3 bg-light rounded">
                                <div>
                                    <i class="bi bi-file-earmark-text me-2"></i>
                                    <span class="fw-bold">{{ uploadState.fileName }}</span>
                                    <small class="text-muted d-block">{{ formatFileSize(uploadState.fileSize) }}</small>
                                </div>
                                <button
                                    type="button"
                                    class="btn btn-sm btn-outline-danger"
                                    (click)="clearFile()"
                                    [disabled]="uploadState.uploading">
                                    <i class="bi bi-x"></i>
                                    {{ 'common.remove' | translate }}
                                </button>
                            </div>
                        </div>

                        <!-- Upload Button -->
                        <button
                            *ngIf="uploadState.file && !uploadState.uploaded && !uploadState.uploading"
                            type="button"
                            class="btn btn-primary"
                            (click)="uploadDocument()"
                            [disabled]="!canUpload">
                            <i class="bi bi-upload me-2"></i>
                            {{ 'seller_setup.upload_button' | translate }}
                        </button>

                        <!-- Uploading Spinner -->
                        <div *ngIf="uploadState.uploading" class="text-center py-3">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
                            </div>
                            <p class="mt-2 mb-0">{{ 'seller_setup.uploading' | translate }}</p>
                        </div>

                        <!-- Success State -->
                        <div *ngIf="uploadState.uploaded" class="alert alert-success">
                            <i class="bi bi-check-circle-fill me-2"></i>
                            {{ 'seller_setup.upload_success' | translate }}
                        </div>

                        <!-- Error State -->
                        <div *ngIf="uploadState.error" class="alert alert-danger">
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>
                            {{ uploadState.error }}
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-danger ms-3"
                                (click)="retryUpload()">
                                {{ 'common.retry' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="onClose()">
                        {{ 'common.cancel' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" style="z-index: 9998;"></div>
</ng-container>
